import React from 'react';

import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import { Theme } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import Toolbar from '@material-ui/core/Toolbar';

import { colorPalette } from '../styles/customStyling';

import logo from '../images/ShorelightLogo.svg';

const styles = (theme: Theme) => ({
  appBar: {
    backgroundColor: colorPalette.white,
    boxShadow: 'none',
    color: colorPalette.slOrange,
    paddingLeft: theme.spacing(20),
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 30 //not using theme.spacing to match shorelight.com
    },
    [theme.breakpoints.down('xs')]: {
      paddingLeft: 15 //not using theme.spacing to match shorelight.com
    }
  },
  toolbar: {
    height: 75,
    padding: 0
  },
  iconButtonRoot: {
    '&:hover': {
      backgroundColor: 'unset'
    }
  },
  link: {
    height: 22
  },
  logo: {
    height: 22
  }
});

// Start typescript definitions
interface OwnProps extends WithStyles<typeof styles> {}
// End typescript definitions

export const Header = ({ classes }: OwnProps) => (
  <AppBar className={classes.appBar} position="static">
    <Toolbar className={classes.toolbar}>
      <Button
        disableRipple={true}
        classes={{
          root: classes.iconButtonRoot
        }}
      >
        <a
          className={classes.link}
          href="https://corporate.shorelight.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={logo} className={classes.logo} alt="logo" />
        </a>
      </Button>
    </Toolbar>
  </AppBar>
);

export default withStyles(styles)(Header);
